import { css } from '@emotion/react';
import Theme from 'App.theme';
import ModernNormalise from 'utils/ModernNormalize';

const GlobalStyles = css`
  ${ModernNormalise}
  html,
	body,
	#root {
    scroll-behavior: smooth;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-family: ${Theme.font};
    color: ${Theme.colours.black};

    .route {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 100vh;

      main {
        flex: 1 0 auto;
      }

      header,
      footer {
        flex: none;
      }
    }
  }
`;

export default GlobalStyles;
